import { render } from "./BarPassageOutcomes.vue?vue&type=template&id=46d3e3fc&scoped=true"
import script from "./BarPassageOutcomes.vue?vue&type=script&lang=js"
export * from "./BarPassageOutcomes.vue?vue&type=script&lang=js"

import "./BarPassageOutcomes.vue?vue&type=style&index=0&id=46d3e3fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d3e3fc"]])

export default __exports__